import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../modal/hooks";
import { APIStatus, SessionStorageKeys } from "../../constants";
import {
	AptitudeIcon,
	ImportantIcon,
	LogicalIcon,
	QuestionIcon1,
	QuestionIcon2,
	QuestionIcon3,
	StarIcon,
	TechnicalIcon,
} from "../../assets/svg";
import { clearGetOneResultDetail } from "../../services/result-detail/result-detail.slice";
import { getOneResultDetails } from "../../services/result-detail/result-details.service";
import { useLocation } from "react-router-dom";
import { Spin } from "antd";
import { Config } from "../../config";
import axios from "axios";
import "./result-details.scss";

export const ResultDetailsList: React.FunctionComponent = () => {
	const location = useLocation();
	const { sID } = location.state;
	const IconArray: { icon: React.FunctionComponent; color: string }[] = [
		{ icon: AptitudeIcon, color: "#9B7EBD" },
		{ icon: ImportantIcon, color: "#B1C29E" },
		{ icon: LogicalIcon, color: "#578E7E" },
		{ icon: TechnicalIcon, color: "#FB6D48" },
		{ icon: QuestionIcon1, color: "#8BC34A" },
		{ icon: QuestionIcon2, color: "#E4EAF8" },
		{ icon: QuestionIcon3, color: "#959CB3" },
	];
	const typeAndWeightage = useAppSelector((store) => store.settings.queTypeAndWeightage);
	const maxWeightage = typeAndWeightage.reduce((acc, item: any) => (item.weightage > acc ? item.weightage : acc), 0);
	const getOneResultDetailsResponse = useAppSelector((store) => store.resultDetail.getOneResultDetailsResponse);
	const getOneResultDetailsCompleted = useAppSelector((store) => store.resultDetail.getOneResultDetailsCompleted);
	const dispatch = useAppDispatch();
	const [loading, setLoading] = useState<boolean>(true);

	const totalQuestionsCount = Object.values(getOneResultDetailsResponse?.totalQuestions ?? {}).reduce(
		(sum, num) => sum + num,
		0
	);

	const answered = useMemo(() => {
		return getOneResultDetailsResponse.answers?.filter((data, index) => data.selectedOption !== null)?.length || 0;
	}, [getOneResultDetailsResponse.answers]);

	useEffect(() => {
		if (sID) {
			setLoading(true);
			dispatch(getOneResultDetails(parseFloat(sID)));
		}
	}, [sID]);

	useEffect(() => {
		if (getOneResultDetailsCompleted === APIStatus.FULFILLED) {
			setLoading(false);
			console.log("getOneResultDetailsResponse", getOneResultDetailsResponse);
			dispatch(clearGetOneResultDetail());
		}
		if (getOneResultDetailsCompleted === APIStatus.REJECTED) {
			setLoading(false);
			dispatch(clearGetOneResultDetail());
		}
	}, [getOneResultDetailsCompleted]);

	return (
		<div className="overview_content_box questions_listing_main_container d-flex flex-column px-4 pt-0">
			<div
				className="grid_listing_container"
				style={typeAndWeightage?.length < 4 ? { display: "flex", justifyContent: "space-between" } : undefined}
			>
				{typeAndWeightage.map((item, index) => {
					const randomIndex = Math.floor(Math.random() * IconArray.length);
					const IconComponent: React.FunctionComponent = IconArray[index]?.icon || IconArray[randomIndex]?.icon;
					return (
						<div
							key={index}
							className="logical_grid d-flex align-items-center justify-content-between"
							style={{ borderLeftColor: IconArray[index]?.color }}
						>
							<div className="logical_icon d-flex align-items-center">
								<IconComponent />
							</div>
							<div className="logical_result d-flex flex-column align-items-center p-2">
								<span>{item.name}</span>
								<span className="percentage">
									{`${getOneResultDetailsResponse?.questionCategoryCounts?.[item.name] ?? 0} / ${
										getOneResultDetailsResponse?.totalQuestions?.[item.name] ?? 0
									}`}
								</span>
							</div>
						</div>
					);
				})}
			</div>
			<div className="answers_listing_container">
				<span className="pl-2 pb-2 font_medium font_18">Answered Questions</span>
				<div className="answer_box_container">
					{loading ? (
						<div className="d-flex align-items-center justify-content-center h-100">
							<Spin />
						</div>
					) : getOneResultDetailsResponse.answers ? (
						<>
							{getOneResultDetailsResponse.answers.length && getOneResultDetailsResponse.answers.length === 0 ? (
								<div className="d-flex align-items-center justify-content-center h-100">No Data</div>
							) : (
								<>
									<div className="answer_box">
										<div className="head">
											<div className="w-50 d-flex align-items-center">
												<div className="d-flex align-items-center">
													<span className="font_regular font_16 text_color">Total Questions:</span>
													<span className="pl-2 font_medium">{totalQuestionsCount}</span>
												</div>
												<div className="pl-4 d-flex align-items-center">
													<span className="font_regular font_16 text_color">Answered:</span>
													<span className="pl-2 font_medium">{answered}</span>
												</div>
											</div>
											<div className="legend_container w-50">
												<div className="legend_item">
													<span className="legend_color not_answered"></span> Not Answered
												</div>
												<div className="legend_item">
													<span className="legend_color correct_answered"></span> Answered Correctly
												</div>
												<div className="legend_item">
													<span className="legend_color wrong_answered"></span> Answered Incorrectly
												</div>
											</div>
										</div>
										<div className="scollable_container flex_1_1_10 overflow-auto">
											{getOneResultDetailsResponse.answers.map((el: any, index) => {
												if (el.question === null) return null;
												const selectedOption = el.selectedOption;
												const correctAnswer = el.options.find((option: any) => option.isCorrect)?.text;
												let questionClass = "questions_listing_box";
												if (!selectedOption) {
													questionClass = "questions_listing_box";
												} else if (selectedOption === correctAnswer) {
													questionClass = "questions_listing_box correct_answered_box";
												} else {
													questionClass = "questions_listing_box wrong_answered_box";
												}
												return (
													<div key={el.question} className={questionClass}>
														<div className="d-flex justify-content-between align-items-start">
															<div className="question_container w-100">
																<div className="d-flex mb-2">
																	<div className="mr-1">{index + 1}.</div>
																	<div className="word_break">{el.question}</div>
																</div>
															</div>
															<div className="weightage d-flex justify-content-end align-items-center w-100">
																<span className="pt_2">{el.type}</span>
																<span className="pl-1">
																	{[...Array(maxWeightage)].map((_, index) => (
																		<span key={index} className="pl-1" style={{ marginRight: "2px" }}>
																			<StarIcon
																				color={index < el.weightage ? "#f7ba02" : "#E8E8E8"}
																				width={16}
																				height={16}
																			/>
																		</span>
																	))}
																</span>
															</div>
														</div>
														{el.questionMedia && (
															<div className="attachment_container mt-2 mb-3">
																<img src={el.questionMedia} alt="Question Media" />
															</div>
														)}
														<div className="answer_content_container">
															{el.options.map((option: any, optIndex: number) => {
																const isSelected = el.selectedOption === option.text;
																const isCorrect = option.isCorrect;
																const isWrongSelection = isSelected && !isCorrect;
																return (
																	<div
																		key={optIndex}
																		className={`answer_box mr-3 ${isCorrect ? "correct_answer" : ""} ${
																			isWrongSelection ? "selected_answer" : ""
																		}`}
																	>
																		<div className="d-flex">
																			<div className="mr-1">{optIndex + 1}.</div>
																			<div className="word_break">{option.text}</div>
																		</div>
																	</div>
																);
															})}
														</div>
													</div>
												);
											})}
										</div>
									</div>
								</>
							)}
						</>
					) : (
						""
					)}
				</div>
			</div>
		</div>
	);
};
